import { IVersion } from "../../shared/types/IVersion";

export const isVersionInitial = (version: IVersion) => {
  return (
    version.RELEASE.toString() === "0000" &&
    version.SERVICE_PACK.toString() === "00" &&
    version.HOTFIX.toString() === "00"
  );
};
